import { FC, ReactNode } from 'react';
import { BoxProps, Flex, FlexProps, Icon, InputGroup, InputLeftElement, NumberDecrementStepper, NumberIncrementStepper, NumberInput, NumberInputField, NumberInputFieldProps, NumberInputProps, NumberInputStepper, Spacer, Text, useMultiStyleConfig } from '@chakra-ui/react';
import ChevronDown from 'ui/components/Icons/ChevronDown';
import ChevronUp from 'ui/components/Icons/ChevronUp/ChevronUp';
export interface CbNumberInputProps extends NumberInputProps {
  decrementStepperChildren?: ReactNode;
  decrementStepperProps?: BoxProps;
  hasSteppers?: boolean;
  icon?: typeof Icon;
  incrementStepperChildren?: ReactNode;
  incrementStepperProps?: BoxProps;
  inputFieldProps?: NumberInputFieldProps;
  label?: string;
  labelColor?: string;
  placeholder?: string;
  stepperContainerProps?: FlexProps;
}
export const CbNumberInput: FC<CbNumberInputProps> = ({
  decrementStepperChildren,
  decrementStepperProps,
  hasSteppers = false,
  icon: LeftIcon,
  incrementStepperChildren,
  incrementStepperProps,
  inputFieldProps,
  label,
  labelColor,
  placeholder,
  stepperContainerProps,
  ...props
}) => {
  const {
    size,
    variant
  } = props;
  const styles = useMultiStyleConfig('NumberInput', {
    size,
    variant: variant || 'cb-test'
  });
  const handleFocus = (e): void => {
    props?.onFocus?.(e);
    inputFieldProps?.onFocus?.(e);
  };
  const handleBlur = (e): void => {
    props?.onBlur?.(e);
    inputFieldProps?.onBlur?.(e);
  };
  return <InputGroup alignItems="center" display="flex" _hover={{
    cursor: 'pointer'
  }} justifyContent="center" justifyItems="center" data-sentry-element="InputGroup" data-sentry-component="CbNumberInput" data-sentry-source-file="CbNumberInput.tsx">
      <InputLeftElement alignItems="center" display="flex" height="100%" justifyContent="center" justifyItems="center" width="auto" data-sentry-element="InputLeftElement" data-sentry-source-file="CbNumberInput.tsx">
        {LeftIcon && <LeftIcon aria-label="number-input-icon" />}
        {label && <Flex flexDirection="column" height="100%" justifyContent="space-between">
            <Text color={labelColor || 'gray.500'} fontSize="xs" paddingLeft={LeftIcon ? 3 : 1} paddingTop="1px">
              {label}
            </Text>
            <Spacer />
          </Flex>}
      </InputLeftElement>
      <NumberInput width="100%" aria-label="number-input" {...props} data-sentry-element="NumberInput" data-sentry-source-file="CbNumberInput.tsx">
        <NumberInputField {...inputFieldProps} fontSize={label ? 'md' : inputFieldProps?.fontSize} onFocus={handleFocus} onBlur={handleBlur} paddingLeft={inputFieldProps?.paddingLeft || 4} paddingTop={label ? 2 : inputFieldProps?.paddingTop} placeholder={placeholder} backgroundColor="transparent" data-sentry-element="NumberInputField" data-sentry-source-file="CbNumberInput.tsx" />
        {hasSteppers && <NumberInputStepper sx={styles.stepperGroup} {...stepperContainerProps}>
            <NumberIncrementStepper aria-label="number-increment" {...incrementStepperProps} sx={styles.stepper}>
              {incrementStepperChildren || <ChevronUp color="gray.600" />}
            </NumberIncrementStepper>
            <NumberDecrementStepper aria-label="number-decrement" {...decrementStepperProps} sx={styles.stepper}>
              {decrementStepperChildren || <ChevronDown color="gray.600" />}
            </NumberDecrementStepper>
          </NumberInputStepper>}
      </NumberInput>
    </InputGroup>;
};